import React from "react";
import PropTypes from "prop-types";
import ActionDetails from "../actionDetails/index.js";
import ActionResponse from "../actionResponse/index.js";
import {
  ActionCardContentContainer,
  VerticalDivider,
} from "./actionCardContentStyles.js";

const ActionCardContent = (props) => {
  const { isBeingReviewed, id, status } = props;

  return (
    <ActionCardContentContainer>
      <ActionDetails {...props} />
      <VerticalDivider />
      {isBeingReviewed && <ActionResponse id={id} status={status} />}
    </ActionCardContentContainer>
  );
};

ActionCardContent.propTypes = {
  isBeingReviewed: PropTypes.bool.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  status: PropTypes.number,
};

export default ActionCardContent;
